export default __webpack_public_path__ + "static/media/expl-dissect_07_EN.77e56ba0.png";